import {FormItemConfigurationModel} from '../form-item-configuration.model';
import {FormResultDataModel} from './form-result-data.model';
import {XauditModel} from '../../xaudit.model';

export class FormItemDataModel extends XauditModel {
    dataFormItemId: string;
    dataFormParagraphID: string;
    CaseWorkItemFormsId: string;
    ItemName: string;
    DFormItemId: string;
    HasChildren: boolean;
    ParentdataFormItemId: string;
    cfgDFormItem: FormItemConfigurationModel;
    dataFormResults: FormResultDataModel[];
    RESULT: FormResultDataModel = new FormResultDataModel();
    RESULTS: FormResultDataModel[];
    RESULT_HOUR: any;
    RESULT_MINUTES: any;
    RESULT_TOP: any;
    RESULT_BOTTOM: any;
    RESULT_VITAL_ONE: any;
    RESULT_VITAL_TWO: any;
    RESULT_VITAL_THREE: any;
}
